<template>
  <div class="popup" v-if="visible == 1 || visible == 2">
    <div class="shadow" @click="close()"></div>
    <div class="container">
      <header>
        <h5>{{ header }}</h5>
        <div class="close" @click="close()">
          <i class="material-icons">close</i>
        </div>
      </header>
      <div class="wrapper">
        <div class="input-container" title="Imię">
          <header>
            <h6>Imię</h6>
          </header>
          <div class="input-box">
            <input type="text" class="data" placeholder="Imię" v-model="name">
          </div>
        </div>
        <div class="input-container" title="Nazwisko">
          <header>
            <h6>Nazwisko</h6>
          </header>
          <div class="input-box">
            <input type="text" class="data" placeholder="Nazwisko" v-model="surname">
          </div>
        </div>
        <!-- <div class="input-container" :title="getIdentityCardText()">
          <header>
            <h6>{{ getIdentityCardText() }}</h6>
          </header>
          <div class="input-box">
            <input type="text" class="data" :placeholder="getIdentityCardText()" :disabled="visible == 2" v-model="pesel">
          </div>
        </div>
        <div class="input-container" v-if="visible == 1">
          <div class="input-checkbox">
            <div class="checkbox" @click="changeIdentityCard()">
                <i class="material-icons" v-if="identity_card == 2">done</i>
            </div>
            <p>Nie mam peselu</p>
          </div>
          <p class="checkbox"></p>
        </div> -->
        <div class="input-container" title="Stanowisko">
          <header>
            <h6>Stanowisko</h6>
          </header>
          <div class="select-box">
            <div 
              class="select-component-container" 
              :class="{ 
                'select-component-container other': position === 'inne',
              }"
              >
              <Select 
                :options="positions"
                :default="position === 'inne' ? 'inne' : (position ? position : 'Wybierz stanowisko')"
                @input="selectPosition($event)"
              />
          </div>
          <input 
            type="text" 
            class="data position"  
            placeholder="Stanowisko*" 
            v-if="position === 'inne'" v-model="otherPosition" 
          >
          </div>
        </div>
        <div class="flex">
          <button class="default small" :class="[getColorShadowClass()]" @click="addPerson()" v-if="visible == 1">Dodaj</button>
          <button class="default small reverse" :class="[getColorShadowClass()]" @click="deletePerson()" v-if="visible == 2">Usuń</button>
          <button class="default small" :class="[getColorShadowClass()]" @click="updatePerson()" v-if="visible == 2">Edytuj</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select from '../Select';

export default {
  name: 'PopupCompanyPersonsContract',
  components: {
    Select,
  },
  data(){
    return{
      header: '',
      name: '',
      surname: '',
      pesel: '',
      position: '',
      otherPosition: '',
      identity_card: 1,
      id: '',
      positions: ['Właściciel', 'Wspólnik', 'Prezes zarządu', 'Wice prezes', 'Członek zarządu', 'Pełnomocnik', 'inne'],
    }
  },
  computed:{
    visible(){
      return this.$store.state.popup;
    },
    api() {
      return this.$store.state.api;
    },
    companyInfoEdit() {
      return this.$store.state.companyInfoEdit;
    },
  },
  watch: {
    visible(){
      this.name = '';
      this.surname = ''
      this.pesel = '';
      this.position = ''
      this.identity_card = 1;
      if(this.visible == 1 || this.visible == 2){
        this.getHeaderText();
      }
      if(this.visible == 2){
        this.name = this.companyInfoEdit.name;
        this.surname = this.companyInfoEdit.surname;
        this.pesel = this.companyInfoEdit.identity_card;
        this.position = this.companyInfoEdit.position;
        this.id = this.companyInfoEdit.id;
      }
    }
  },
  methods: {
    close(){
      this.$store.commit('togglePopup', 0);
      document.body.style = "overflow-y: overlay";
    },
    enter(){
      if(this.visible == 1){
        this.addPerson();
      }else if(this.visible == 2){
        this.updatePerson();
      }
    },
    getHeaderText(){
      if(this.visible == 1){
        this.header = 'Dodaj nową osobę';
      }else if(this.visible == 2){
        this.header =  'Edytuj osobę';
      }
    },
    getColorShadowClass(){
      switch(parseInt(localStorage.companyColor)){
        case 1:
          return 'gradient-orange-shadow';
        case 2:
          return 'gradient-blue-shadow';
        case 3:
          return 'gradient-red-shadow';
        case 4:
          return 'gradient-green-shadow';
        case 5:
          return 'gradient-pink-shadow';
        case 6:
          return 'gradient-purple-shadow';
      }
    },
    getIdentityCardText(){
      if(this.visible == 1){
        if(this.identity_card == 1){
          return 'Pesel';
        }else{
          return 'Paszport'
        }
      }else{
        if(this.companyInfoEdit.identity_card_type == 1){
          return 'Pesel';
        }else{
          return 'Paszport'
        }
      }
    },
    changeIdentityCard(){
      if(this.identity_card == 1){
        this.identity_card = 2;
      }else{
        this.identity_card = 1;
      }
    },
    addPerson(){
      let self = this;
      let position = '';
      if(this.position == 'inne') {
        position = this.otherPosition;
      } else {
        position = this.position;
      };
      this.axios
      .post(this.api + 'panel/company/signers',  { name: this.name, surname: this.surname, pesel: this.pesel, identityCardType: this.identity_card, position: position, nip: localStorage.companyNip, }, 
        { headers: { Authorization: localStorage.accessToken } })
      .then(response => {
        if(response.data.status){
          self.close();
          this.name = '';
          this.surname = ''
          this.pesel = '';
          this.position = ''
          this.identity_card = 1;
        }
        self.$store.commit('toggleCompanyEdit');
        self.$store.commit('toggleAlert', {
          visibility: 1,
          type: response.data.status,
          msg: response.data.msg
        });
      });
    },
    updatePerson(){
      let self = this;
      let position = '';
      if(this.position == 'inne') {
        position = this.otherPosition;
      } else {
        position = this.position;
      };
      this.axios
      .put(this.api + 'panel/company/signers',  { name: this.name, surname: this.surname, pesel: this.pesel, identityCardType: this.identity_card, position: position, id: this.id, nip: localStorage.companyNip, }, 
        { headers: { Authorization: localStorage.accessToken } })
      .then(response => {
        if(response.data.status){
          self.close();
          this.name = '';
          this.surname = ''
          this.pesel = '';
          this.position = '';
          this.identity_card = 1;
        }
        self.$store.commit('toggleCompanyEdit');
        self.$store.commit('toggleAlert', {
          visibility: 1,
          type: response.data.status,
          msg: response.data.msg
        });
      });
    },
    deletePerson(){
      console.log(this.pesel)
      let self = this;
      this.axios
      .delete(this.api + 'panel/company/signers', { data: { id: this.id, nip: localStorage.companyNip }}, 
        { headers: { Authorization: localStorage.accessToken } })
      .then(response => {
        if(response.data.status){
          self.close();
          this.name = '';
          this.surname = ''
          this.pesel = '';
          this.position = ''
        }
        self.$store.commit('toggleCompanyEdit');
        self.$store.commit('toggleAlert', {
          visibility: 1,
          type: response.data.status,
          msg: response.data.msg
        });
      });
    },
    selectPosition(position) {
      if(position != 'inne') {
        this.otherPosition = position;
      };
      this.position = position;
    },
  },
}
</script>
<style scoped lang="scss">
  div.input-container { width: 300px; margin: 10px auto; }
  div.input-container div.input-box { width: 300px; }
  div.input-container div.input-box input { width: 300px; }
  div.popup div.wrapper div.flex { display: flex; justify-content: space-between; width: 300px; margin: 0 auto; }
  div.popup div.wrapper button { margin: 15px 0 30px 0; }

  .select-box { display: flex; }
  .select-component-container { width: 100%; }
  .select-component-container.other { width: 50%; margin-right: 10px; }
  .select-component-container.other-selected { display: none; }
  input.data.position { width: 100%; }
</style>
